import { registerDestructor } from '@ember/destroyable';
import Modifier from 'ember-modifier';

export default class ShiftFocusToParentModifier extends Modifier {
  element = null;

  cleanup = instance => {
    let { element } = instance;

    element.removeEventListener('blur', this.onBlur);
    element.removeEventListener('focus', this.onFocus);

    this.element = null;
  };

  modify = element => {
    this.element = element;

    this.element.addEventListener('focus', this.onFocus);
    this.element.addEventListener('blur', this.onBlur);

    registerDestructor(this, this.cleanup);
  };

  // the parent element's stylesheet must provide a .focus class for styles to be applied properly
  onBlur = () => this.element.parentElement.classList.remove('focus');
  onFocus = () => this.element.parentElement.classList.add('focus');
}
